import React from "react";
import hbg from "./groupbg.png";
import Fade from 'react-reveal/Fade';
import { Dimensions } from '../../Helper/sitedimension';
import './contactushero.css';



const ContactUsHero = () => {

  const { width } = Dimensions.useWindowDimensions();

  return (
    <div className="container-fluid contactushero">
      <div className="row">
        <div className="col-7 d-flex align-items-center">
          <div style={{ paddingLeft: "13%", paddingRight: "40%" }}>
            <h2
              className="font-weight-bold text-left"
              style={{ fontSize: "3em", color: "black", fontStyle: "Roboto", width: "300px" }}
            >
              <Fade delay={300}>
                Contact Us
                </Fade>
            </h2>
            <br />
            <p className=" text-left margin-top-s" style={{ width: "100%" }}>
              <Fade delay={600}>Reach out to us and get your hands on our AI-enabled cyber security Product & Servies.</Fade>
            </p>
          </div>
        </div>
        <div className="col-5 p-0">
          {width > 500 ?
            <img
              alt="Web Studio"
              class="img-fluid contacthero-image"
              style={{ float: "right", width: "90%" }}
              src={hbg}
            /> : null}
        </div>
      </div>
    </div>
  );
};

export default ContactUsHero;
